module.exports = __webpack_public_path__ + "media/img/lifetime-ui2-09d109168069e10058c468939cd9d0c6.svg";